import { toastr } from 'react-redux-toastr';
import { getApiErrorJson } from 'edgify-agent-api';
import * as Service from '../../server/RestClients';

export const GET_SETTINGS_LOADING = 'GET_SETTINGS_LOADING';
export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS';
export const GET_SETTINGS_FAILURE = 'GET_SETTINGS_FAILURE';
export const SET_SETTINGS_LOADING = 'SET_SETTINGS_LOADING';
export const SET_SETTINGS_SUCCESS = 'SET_SETTINGS_SUCCESS';
export const SET_SETTINGS_FAILURE = 'SET_SETTINGS_FAILURE';

export const getSettings = (config) => async (dispatch) => {
  dispatch({
    type: GET_SETTINGS_LOADING,
  });
  try {
    const settings = await Service.getSettings(config);
    dispatch({
      type: GET_SETTINGS_SUCCESS,
      payload: settings,
    });
  } catch (e) {
    toastr.error('Failed to fetch settings', 'Please check your connection');
    dispatch({
      type: GET_SETTINGS_FAILURE,
      payload: e,
    });
  }
};

export const setSettings = (config, settings) => async (dispatch) => {
  dispatch({
    type: SET_SETTINGS_LOADING,
  });
  try {
    const newSettings = await Service.setSettings(config, settings);
    dispatch({
      type: SET_SETTINGS_SUCCESS,
      payload: newSettings,
    });
    await Service.restartAgent(config);
  } catch (e) {
    const errors = getApiErrorJson(e)?.json?.errors ?? [e?.message];
    toastr.error(`invalid settings:\n${errors.map(String).join('\n')}`);

    dispatch({
      type: SET_SETTINGS_FAILURE,
      payload: e,
    });
  }
};
